<template>
    <div class="debug-page">
        <h3>Job Offers</h3>

        <div class="peribox">
            <div class="perititle">
                <div>Hammer job offer</div>
            </div>

            <el-select v-model="driver_id" placeholder="Driver"  style="width: 100%" filterable>
                <el-option v-for="d in drivers"
                        :key="d.id"
                        :label="d.name"
                        :value="d.id"
                ></el-option>
            </el-select>

            <input type="text" placeholder="Job ID" class="form-control" v-model="job_id"></input>

            <textarea type="text" placeholder="Message" class="form-control" v-model="body"></textarea>

            <btn :click="sendOffer">Receive message</btn>
        </div>

        <div class="peribox">
            <div class="perititle">
                <div>Job Offers</div>
                <div class="periicons">
                    <i class="far fa-sync-alt" @click="refresh"></i>
                </div>
            </div>
            <table class="peritable" v-loading="loading">
                <tbody>
                <tr>
                    <th v-for="c in columns">{{ c }}</th>
                </tr>
                <tr v-for="row in rows">
                    <td v-for="c in columns">{{ row ? row[c] : '' }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'data'
    ],
    data() {
        let columns = [
            'id',
            'hammer_driver_id',
            'jobboard_driver_id',
            'message',
            'job_id',
            'queued_at',
            'delivery_started_at',
            'synced_at'
        ];

        return {
            loading: false,
            columns: columns,
            rows: [],
            drivers: [],

            driver_id: '',
            body: '',
            job_id: ''
        };
    },
    methods: {
        refresh() {
            this.loading = true;
            axios.get(url(`job-offers/debug/data`))
                .then((response) => {
                    this.rows = response.data.list;
                    this.loading = false;
                });
        },
        refreshDrivers() {
            axios.get(url(`job-offers/debug/drivers`))
                .then((response) => {
                    this.drivers = response.data;
                });
        },
        sendOffer() {
            return axios.post(url(`job-offers/debug/send`), {
                message: this.body,
                job_id: this.job_id,
                driver_id: this.driver_id
            }).then((response) => {
                this.refresh();
            });
        }
    },
    mounted() {
        this.refresh();
        this.refreshDrivers();
    }
}
</script>